import bounceApiClient from 'legacy/common/utils/bounceApiClient';

import {
  CreateOrganizationTitleDto,
  OrganizationTitleResponseDto,
  OrganizationTitlesListResponseDto,
  ReorderOrganizationTitlesDto,
  UpdateOrganizationTitleDto
} from 'api/dtos/organizations/titles';

export async function createOrganizationTitle({
  organizationId,
  title
}: {
  organizationId: string;
  title: CreateOrganizationTitleDto;
}): Promise<OrganizationTitleResponseDto> {
  const { data } = await bounceApiClient.post(
    `/api/organizations/${organizationId}/titles`,
    title
  );

  return data;
}

export async function getOrganizationTitles(
  organizationId: string,
  useUnauthenticatedEndpoint = false
): Promise<OrganizationTitlesListResponseDto> {
  const endpoint = useUnauthenticatedEndpoint 
    ? `/service/organizations/${organizationId}/titles`
    : `/api/organizations/${organizationId}/titles`;

  const { data } = await bounceApiClient.get(endpoint);

  return data;
}

export async function updateOrganizationTitle({
  organizationId,
  titleId,
  title
}: {
  organizationId: string;
  titleId: string;
  title: UpdateOrganizationTitleDto;
}): Promise<OrganizationTitleResponseDto> {
  const { data } = await bounceApiClient.put(
    `/api/organizations/${organizationId}/titles/${titleId}`,
    title
  );

  return data;
}

export async function deleteOrganizationTitle({
  organizationId,
  titleId
}: {
  organizationId: string;
  titleId: string;
}): Promise<void> {
  await bounceApiClient.delete(
    `/api/organizations/${organizationId}/titles/${titleId}`
  );
}

export async function reorderOrganizationTitles({
  organizationId,
  data
}: {
  organizationId: string;
  data: ReorderOrganizationTitlesDto;
}): Promise<void> {
  await bounceApiClient.put(
    `/api/organizations/${organizationId}/titles/reorder`,
    data
  );
}

export async function getOrganizationTitle({
  organizationId,
  titleId
}: {
  organizationId: string;
  titleId: string;
}): Promise<OrganizationTitleResponseDto> {
  const { data } = await bounceApiClient.get(
    `/api/organizations/${organizationId}/titles/${titleId}`
  );

  return data;
}

export async function assignTitlesToMember({
  organizationId,
  memberId,
  titles
}: {
  organizationId: string;
  memberId: string;
  titles: string[];
}): Promise<void> {
  await bounceApiClient.put(
    `/api/organizations/${organizationId}/members/${memberId}/titles`,
    {
      titles
    }
  );
}

export async function removeTitleFromMember({
  organizationId,
  userId,
  titleId
}: {
  organizationId: string;
  userId: string;
  titleId: string;
}): Promise<void> {
  await bounceApiClient.delete(
    `/api/organizations/${organizationId}/members/${userId}/titles/${titleId}`
  );
}
